import React from "react";
import * as echarts from "echarts";
import moment from "moment";
import close from "../../minimise_button.png";

class MultiAxisChartHydrograph extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef(); // Reference to the chart container
  }

  componentDidMount() {
    this.initializeChart();
    window.addEventListener("resize", this.resizeChart);
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose(); // Dispose chart on unmount
    }
    window.removeEventListener("resize", this.resizeChart);
  }

  resizeChart = () => {
    if (this.chart) {
      this.chart.resize();
    }
  };

  initializeChart() {
    const { data, categories, charttitle } = this.props;

    // Parse and clean the data
    const dischargeData = data[1].map(Number).filter((n) => !isNaN(n));
    const rainfallData = data[0].map(Number).filter((n) => !isNaN(n));

    // Initialize the chart
    this.chart = echarts.init(this.chartRef.current);

    const options = {
      title: {
        text: charttitle,
        left: "center",
        top: 20,
      },
    
      
      tooltip: {
        trigger: "axis",
      
        formatter: (params) => {
          const discharge = params.find((p) => p.seriesName === "Discharge");
          const rainfall = params.find((p) => p.seriesName === "Rainfall");
          return `
            Date: ${params[0].axisValue}<br/>
            Discharge: ${discharge?.data || "N/A"} cumecs<br/>
            Rainfall: ${rainfall?.data || "N/A"} mm
          `;
        },
      },
      grid: {
        top: 80,
        bottom: 60,
        left: 60,
        right: 60,
      },
      xAxis: {
        type: "category",
        data: categories,
        axisLabel: {
          rotate: -25,
        },
      },
      yAxis: [
        {
          type: "value",
          name: "Discharge (cumecs)",
          position: "left",
          nameLocation: "middle",
          alignTicks: true,
          
          nameGap: 40,
          axisLine: {
            lineStyle: {
              color: "#5470C6", // Line color matches series
            },
          },
          axisLabel: {
            formatter: "{value}",
          },
        
        },
        {
          type: "value",
          name: "Rainfall (mm)",
          position: "right",
                alignTicks: true,

          inverse: true, // Reverse the axis
          nameLocation: "middle",
          nameGap: 40,
          axisLine: {
            lineStyle: {
              color: "#91CC75", // Line color matches series
            },
          },
          axisLabel: {
            formatter: "{value}",
          },
          splitLine: {
            // lineStyle: {
            //   type: 'dashed',
            //   color:"#FF0000",
            // }
            show:false,
          },
        },
      ],
      series: [
        {
          name: "Discharge",
          type: "line",
          data: dischargeData,
          yAxisIndex: 0, // Bind to left y-axis
          smooth: true,
          symbolSize: 6,
          color: "#5470C6", // Line color
          markLine: {
            data: [
              {
                xAxis: this.props.curr_date + " 14:00", // Your annotation's X-axis value
                label: {
                  formatter: "Forecast Date", // Annotation text
                  position: "insideEndTop", // Position of the label
                  color: "#fff", // Label text color
                  backgroundColor: "#6b91ff", // Background color for the label
                  padding: [4, 8], // Padding around the label
                },
                lineStyle: {
                  type: "solid", // Line style: solid, dashed, or dotted
                  color: "#6b91ff", // Line color
                  width: 2, // Line width
                },
              },
            ],
          },
        },
        {
          name: "Rainfall",
          type: "bar",
          data: rainfallData,
          yAxisIndex: 1, // Bind to right y-axis
          smooth: true,
          symbolSize: 6,
          color: "#91CC75", // Line color
        },
        
      ],
     
      
     

      toolbox: {
        show: true,
        feature: {
        
          magicType: {
            type: ["bar", "line"],
            title: {
              line: "Line Chart",
              bar: "Bar Chart",
            },
          },
          restore: {
            title: "Restore",
          },
          myClose: {
            show: true,
            title: "Minimize",
            icon: `image://${close}`,
            onclick: this.props.toggleVisibleGraphPanel,
          },
      
        },
    
      },
      dataZoom: [
        {
          type: "inside", // Allows zooming with mouse/touch
          xAxisIndex: 0,
        },
        {
          type: "inside",
          yAxisIndex: 0,
        },
      ]
    

    };

    this.chart.setOption(options);
  }

  render() {
    console.log("ddddecharts",this.props.curr_date)
    return (
      <div>
        <div
          ref={this.chartRef}
          style={{ height: "290px", margin: "auto" }}
        />
      </div>
    );
  }
}

export default MultiAxisChartHydrograph;
